import type { Owner } from "../types";

/**
 * Formats an Owner's name for display — "First MI. Last" with a single period
 * on the middle initial. Falls back to the provided string when every part is
 * blank (e.g. an unsaved roster row rendering during validation).
 *
 * Strips any user-typed trailing period on the MI before re-appending the
 * display period — otherwise entering "T." renders as "T.." downstream.
 *
 * Shared across StepStructure / StepReview / StepThankYou so the formatting
 * stays in sync as fields evolve (previously three near-duplicate copies).
 */
export function ownerDisplayName(owner: Owner, fallback: string): string {
  const miDisplay = (owner.mi ?? "").replace(/\.+$/, "");
  const parts = [owner.firstName, miDisplay ? `${miDisplay}.` : "", owner.lastName]
    .filter((s) => (s ?? "").trim());
  const joined = parts.join(" ").replace(/\s+/g, " ").trim();
  return joined || fallback;
}
